/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const HEROS_SERVICE = {postHero, getHeros, putHero, getHeroById, deleteHeroById, putHeroStatusById};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Heros";

/* Services */
//Service to create hero content
function postHero(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get paginated hero content
function getHeros(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}


//Service to update hero content
function putHero(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get hero details
function getHeroById(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };


    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to delete heros
function deleteHeroById(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'DELETE',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to change hero status
function putHeroStatusById(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, 'status', id]);

    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null , requestOptions);
}

